<template>
  <div class="split-table-wrapper">
    <slot></slot>
    <RkTable :data="eventList" :loading="loading" :finished="finished">
      <RkTableColumn prop="reportDate" label="报告日期" :width="`${postcssPatch(100)}`" align="left">
        <template #default="{ row }">{{ $digitjs(row.reportDate).isNull() }}</template>
      </RkTableColumn>
      <RkTableColumn prop="splitType" label="方式">
        <template #default="{ row }">{{ $digitjs(row.splitType).isNull() }}</template>
      </RkTableColumn>
      <RkTableColumn prop="splitRatio" label="比例" :width="`${postcssPatch(100)}`">
        <template #default="{ row }">{{ $digitjs(row.splitRatio).isNull() }}</template>
      </RkTableColumn>
      <RkTableColumn prop="exDate" label="除净日" :width="`${postcssPatch(100)}`">
        <template #default="{ row }">{{ $digitjs(row.exDate).isNull() }}</template>
      </RkTableColumn>
    </RkTable>
  </div>
</template>

<script>
import { postcssPatch } from '@/utils/postcssPatch'

export default {
  data() {
    return {
      loading: false,
      finished: false,
      eventList: []
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    }
  },
  created() {
    this.getEventList()
  },
  methods: {
    postcssPatch,
    async getEventList() {
      this.loading = true
      const res = await this.$post(this.$api.f10[this.market] + '/summary/ca-splits', {
        startDate: '1990-01-01',
        symbol: this.symbol
      })
      this.eventList = res.data ?? []
      this.finished = true
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.split-table-wrapper {
  padding: 0 var(--edge-padding) var(--edge-padding);
  background: var(--bg-color-2);
}
</style>
